export interface TenantInfo {
    Current: boolean,
    DisplayName: string,
    DomainName: string,
    TenantId: string
}

interface GraphData<T> {
  "odata.metadata": string,
  "value": T[]
}

interface TenantDetails {
  "odata.type": "Microsoft.DirectoryServices.TenantDetail",
  displayName: string,
  verifiedDomains: {
    default: boolean,
    id: string,
    initial: boolean,
    name: string,
    type: string
  }[]
}

const graphApiVersion = '1.6';
const graphApiRoot = 'https://graph.windows.net'
export class GraphApi {
  constructor(private token: string) {    
  }

  public getTenantDetails(tenantId: string) : JQueryPromise<TenantInfo> {
    return this.get(`${graphApiRoot}/${tenantId}/tenantDetails?api-version=${graphApiVersion}`)
      .then((details: GraphData<TenantDetails>) => {
        const td = details.value[0];
        const defaultDomains = td.verifiedDomains.filter(x => x.default);
        if (defaultDomains.length) {
          const ti: TenantInfo = {
            Current: true,
            DisplayName: td.displayName,
            DomainName: defaultDomains[0].name,
            TenantId: tenantId
          }
          return $.Deferred().resolve(ti);
        }
        return $.Deferred().reject("no default domain found");
      });
  }

  private get authHeader() : string {
    return `Bearer ${this.token}`;
  }

  private get<T>(url: string) : JQueryPromise<T> {
    return $.ajax({
      url: url,
      type: 'GET',
      dataType: 'json',
      headers: {
          'Authorization': this.authHeader,
          'Accept': 'application/json,*/*'
      }
    });
  }
}


// WEBPACK FOOTER //
// ./Client/Services/GraphApi.ts